module.exports = __webpack_public_path__ + "img/i01.012cb964.svg";